// Lightweight dark-mode persistence. Tailwind is configured for the
// `[data-mode="dark"]` selector (see tailwind.config.js), and the shadcn
// tokens also react to the `.dark` class — we set both for safety.

export type ThemeMode = "light" | "dark";

const STORAGE_KEY = "theme-mode";

export const getStoredTheme = (): ThemeMode =>
  localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";

export const storeTheme = (mode: ThemeMode) => {
  localStorage.setItem(STORAGE_KEY, mode);
};

export const applyTheme = (mode: ThemeMode) => {
  const root = document.documentElement;
  root.setAttribute("data-mode", mode);
  root.classList.toggle("dark", mode === "dark");
  root.classList.toggle("light", mode === "light");
};

// Apply the persisted theme as early as possible (called on app boot).
export const initTheme = () => applyTheme(getStoredTheme());
